import React, { useState, useRef } from 'react';
import { Box, Typography, Avatar, Menu, MenuItem, ListItemIcon, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { User, Settings, LogOut } from 'lucide-react';

function UserProfileMenu() {
  const { currentUser, userData, logout } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const menuRef = useRef(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  // Get first letter of name or email for avatar
  const getInitial = () => {
    if (userData?.username) {
      return userData.username.charAt(0).toUpperCase();
    }
    return currentUser?.email?.charAt(0).toUpperCase() || 'U';
  };

  return (
    <Box>
      <Box 
        onClick={handleClick}
        sx={{ 
          display: 'flex', 
          alignItems: 'center',
          cursor: 'pointer',
          '&:hover': { opacity: 0.8 }
        }}
      >
        <Avatar 
          sx={{ 
            bgcolor: 'primary.main',
            width: 40,
            height: 40
          }}
        >
          {getInitial()}
        </Avatar>
      </Box>
      
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        ref={menuRef}
        PaperProps={{
          sx: {
            width: 220,
            mt: 1,
            bgcolor: 'background.paper',
            boxShadow: 3
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <Box sx={{ px: 2, py: 1.5 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
            {userData?.username || 'User'}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
            {currentUser?.email}
          </Typography>
        </Box>
        
        <Divider />
        
        <MenuItem onClick={() => { handleClose(); navigate('/sessions'); }}>
          <ListItemIcon>
            <User size={18} />
          </ListItemIcon>
          Sessions
        </MenuItem>
        
        <MenuItem onClick={() => { handleClose(); navigate('/settings'); }}>
          <ListItemIcon>
            <Settings size={18} />
          </ListItemIcon>
          Settings
        </MenuItem>
        
        <Divider />
        
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogOut size={18} />
          </ListItemIcon>
          Log out
        </MenuItem>
      </Menu>
    </Box>
  );
}

export default UserProfileMenu; 